module Meevo.Plugins.MeevoMessenger {

    export class MeevoMessengerClientSideNav implements ng.IDirective {
        restrict = 'E';
        templateUrl = 'app/plugins/meevoMessenger/directives/meevoMessengerClientSideNav/meevoMessengerClientSideNavTemplate.html';
        replace = true;
        controller = 'meevo.plugins.meevoMessenger.MeevoMessengerClientSideNavController';
        controllerAs = 'vm';
        scope = {
            client: '='
        };
   
        constructor(protected identityService: Meevo.Components.Common.IIdentityService) { }

        link = (scope: any, element: JQuery, attr: angular.IAttributes) => {
            // It's necessary to start correctly meevo-client-detail-accordion
            scope.isSingleLocation = (): boolean => {
                if (Model.Guard.isSomething(this.identityService.current().isSingleLocation))
                    return this.identityService.current().isSingleLocation;
                else
                    return false;
            }
        }

        static factory(): angular.IDirectiveFactory {
            let directive = (identityService) => {
                return new MeevoMessengerClientSideNav(identityService);
            };

            directive.$inject = [];

            return directive;
        }
    }

    angular.module('meevo.plugins.meevoMessenger')
        .directive('meevoMessengerClientSideNav', MeevoMessengerClientSideNav.factory());
}
